import apiClient from './api';

export const themeService = {
  async getActiveTheme() {
    const response = await apiClient.get('/themes/active');
    return response.data;
  },

  async getAllThemes() {
    const response = await apiClient.get('/themes/');
    return response.data;
  },

  async createTheme(themeData) {
    const response = await apiClient.post('/themes/', themeData);
    return response.data;
  },

  async updateTheme(themeId, themeData) {
    const response = await apiClient.put(`/themes/${themeId}`, themeData);
    return response.data;
  },

  async deleteTheme(themeId) {
    const response = await apiClient.delete(`/themes/${themeId}`);
    return response.data;
  },

  async initializeDefaultTheme() {
    const response = await apiClient.post('/themes/init-default');
    return response.data;
  }
};